import React, { useState } from 'react';
import { X, Calendar, Clock, MapPin } from 'lucide-react';
interface ScheduleVisitModalProps {
  isOpen: boolean;
  onClose: () => void;
  plotTitle?: string;
  location?: string;
}
export function ScheduleVisitModal({
  isOpen,
  onClose,
  plotTitle = 'Premium Corner Plot',
  location = 'Hinjewadi, Pune'
}: ScheduleVisitModalProps) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [type, setType] = useState('physical');
  if (!isOpen) return null;
  return <div data-testid="schedule-visit-modal-overlay" className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-744">
      <div data-testid="schedule-visit-modal" className="bg-white w-full max-w-md border border-gray-300 shadow-xl relative animate-in fade-in zoom-in-95 duration-200" data-id="element-745">
        <div className="flex justify-between items-center p-6 border-b border-gray-200" data-id="element-746">
          <h2 data-testid="schedule-visit-modal-title" className="text-xl font-bold" data-id="element-747">
            Schedule Site Visit
          </h2>
          <button data-testid="schedule-visit-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-748">
            <X className="w-5 h-5" data-id="element-749" />
          </button>
        </div>

        <div className="p-6 space-y-4" data-id="element-750">
          <div data-testid="schedule-visit-plot-info" className="bg-gray-50 p-3 border border-gray-200" data-id="element-751">
            <h3 data-testid="schedule-visit-plot-title" className="font-bold text-sm mb-1" data-id="element-752">
              {plotTitle}
            </h3>
            <p data-testid="schedule-visit-location" className="text-xs text-gray-500 flex items-center gap-1" data-id="element-753">
              <MapPin className="w-3 h-3" data-id="element-754" /> {location}
            </p>
          </div>

          <div data-id="element-755">
            <label className="block text-xs font-bold uppercase text-gray-500 mb-2" data-id="element-756">
              Visit Type
            </label>
            <div className="flex gap-4" data-id="element-757">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-758">
                <input data-testid="visit-type-physical-radio" type="radio" name="visitType" value="physical" checked={type === 'physical'} onChange={e => setType(e.target.value)} className="accent-[#1f2933]" data-id="element-759" />
                <span className="text-sm" data-id="element-760">Physical Visit</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-761">
                <input data-testid="visit-type-virtual-radio" type="radio" name="visitType" value="virtual" checked={type === 'virtual'} onChange={e => setType(e.target.value)} className="accent-[#1f2933]" data-id="element-762" />
                <span className="text-sm" data-id="element-763">Video Call Tour</span>
              </label>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-764">
            <div data-id="element-765">
              <label className="block text-xs font-bold uppercase text-gray-500 mb-1" data-id="element-766">
                Date
              </label>
              <div className="relative" data-id="element-767">
                <Calendar className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" data-id="element-768" />
                <input data-testid="schedule-visit-date-input" type="date" className="w-full pl-10 pr-3 py-2 border border-gray-300 focus:outline-none focus:border-[#1f2933]" value={date} onChange={e => setDate(e.target.value)} data-id="element-769" />
              </div>
            </div>
            <div data-id="element-770">
              <label className="block text-xs font-bold uppercase text-gray-500 mb-1" data-id="element-771">
                Time
              </label>
              <div className="relative" data-id="element-772">
                <Clock className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" data-id="element-773" />
                <select data-testid="schedule-visit-time-select" className="w-full pl-10 pr-3 py-2 border border-gray-300 focus:outline-none focus:border-[#1f2933] bg-white" value={time} onChange={e => setTime(e.target.value)} data-id="element-774">
                  <option value="" data-id="element-775">Select Time</option>
                  <option value="10:00" data-id="element-776">10:00 AM</option>
                  <option value="11:00" data-id="element-777">11:00 AM</option>
                  <option value="14:00" data-id="element-778">02:00 PM</option>
                  <option value="16:00" data-id="element-779">04:00 PM</option>
                </select>
              </div>
            </div>
          </div>

          <div data-id="element-780">
            <label className="block text-xs font-bold uppercase text-gray-500 mb-1" data-id="element-781">
              Additional Notes
            </label>
            <textarea data-testid="schedule-visit-notes-input" className="w-full p-3 border border-gray-300 focus:outline-none focus:border-[#1f2933] h-24 resize-none text-sm" placeholder="Any specific questions or requirements?" data-id="element-782"></textarea>
          </div>
        </div>

        <div className="flex justify-end gap-3 p-6 border-t border-gray-200" data-id="element-783">
          <button data-testid="schedule-visit-cancel-btn" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-784">
            Cancel
          </button>
          <button data-testid="schedule-visit-confirm-btn" onClick={() => {
          onClose();
        }} className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-785">
            Confirm Booking
          </button>
        </div>
      </div>
    </div>;
}